<template>
    <b-form-group
        :label="label"
    >
        <b-form-input
            :id="id"
            :value="formatedDate"
            :placeholder="placeholder"
        ></b-form-input>
    </b-form-group>
</template>
<script>
export default {
    name: 'date_time_picker_2',
    props: {
        label: {
            type: String,
            default: ''
        },
        id: {
            type: String,
            default: () => (`datepicker-${parseInt(Math.random() * 1000000)}`)
        },
        
        outputFormat: {
            type: String,
            default: 'YYYY-MM-DD'
        },
        auto: {
            type: Boolean,
            default: false
        },
        minDate: {
            type: [Object, String],
            default: ''
        },
        maxDate: {
            type: [Object, String],
            default: ''
        },
        value: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        }
    },
    data: () => ({
        selectedDate: '',
        momentFormat: 'DD/MM/YYYY'
    }),
    watch: {
        value(val) {
            if(!val) return $(`#${this.id}`).datepicker('setDate', null);
        }
    },
    computed: {
        formatedDate() {
            if(!this.selectedDate) return '';

            return moment(this.selectedDate, this.outputFormat).format(this.momentFormat);
        }
    },
    mounted() {
        $(`#${this.id}`).datepicker({
            dateFormat: 'dd/mm/yy',
            minDate: this.minDate,
            maxDate: this.maxDate,
            onSelect: text => {
                const selDate = moment(text, this.momentFormat).format(this.outputFormat);
                this.selectedDate = selDate;
                this.$emit('input', selDate);
                this.$emit('change', selDate);
            }
        });

        if(this.auto && !this.value) {
            this.selectedDate = moment().format(this.outputFormat);
            this.$emit('input', this.selectedDate);
            this.$emit('change', this.selectedDate);
        }

        if(!!this.value) {
            const patterns = {
                '^\\d{2}/\\d{2}/\\d{4}': 'DD/MM/YYYY',
                '^\\d{4}-\\d{2}-\\d{2}': 'YYYY-MM-DD',
            }

            const pattern = Object.keys(patterns).find(p => (new RegExp(p)).test(this.value));

            if(!pattern) return;

            const date = moment(this.value, patterns[pattern]);

            this.selectedDate = date.format(this.outputFormat);
        }
    }
}
</script>